const ViewProps = {
    init() {
        this.cacheDom()
        this.resize()
        window.addEventListener('resize', this.resize.bind(this))
    },

    cacheDom() {
        this.adminBar = document.querySelector('#wpadminbar')
    },

    resize() {
        const adminBarHeight = this.adminBar ? this.adminBar.offsetHeight : 0
        document.documentElement.style.setProperty('--admin-bar-height', `${adminBarHeight}px`)
    },
}

export default ViewProps